import styled from "styled-components";

import { PageTitle } from "shared/ui/layout/PageTitle";

export const AddHeader = ({ pageName, onClick, buttonValue }) => {
  return (
    <Manage>
      <PageTitle pageName={pageName} />
      <RegisterButton onClick={onClick}>{buttonValue}</RegisterButton>
    </Manage>
  );
};

const Manage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin-left: 50px; */
  margin-bottom: 15px;
  /* padding-top: 26px; */
`;
const RegisterButton = styled.button`
  width: 153px;
  height: 42px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: var(--admin-blue-default-blue, #0079e0);
  color: white;
  border: #0079e0;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  //padding-top: 10px;
`;
